const cropStageProgram = {
  noProducts: Drupal.t('0 products'),
  pdfLinkText: Drupal.t('Download full crop plan'),
  pdfText: Drupal.t('Do you want to take this information with you?'),
  productsTitle: Drupal.t('Products used in this stage'),
};

export default cropStageProgram;
